export default __webpack_public_path__ + "static/media/jarvis.912d2333.png";